import AtendimentoGrupo from "./AtendimentosGrupo";
import MeusAtendimentos from "./MeusAtendimentos";
import TodosAtendimentos from "./TodosAtendimentos";

export const GestaoAtendimentoAoCliente = {
    MeusAtendimentos,
    TodosAtendimentos,
    AtendimentoGrupo,
};
